export enum ProductTypeCodeEnum {
  DOPUNSKO = 'supplementary',
  DODATNO = 'additional'
}
